import React from 'react';

export const AddornmentIcon = ({
  width = 24,
  height = 24,
  color = '#656565',
}) => (
  <svg
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.83366 12.5H8.33366C8.79199 12.5 9.16699 12.875 9.16699 13.3334C9.16699 13.7917 8.79199 14.1667 8.33366 14.1667H5.83366C3.53366 14.1667 1.66699 12.3 1.66699 10C1.66699 7.70004 3.53366 5.83337 5.83366 5.83337H8.33366C8.79199 5.83337 9.16699 6.20837 9.16699 6.66671C9.16699 7.12504 8.79199 7.50004 8.33366 7.50004H5.83366C4.45866 7.50004 3.33366 8.62504 3.33366 10C3.33366 11.375 4.45866 12.5 5.83366 12.5ZM14.1673 5.83337H11.6673C11.209 5.83337 10.834 6.20837 10.834 6.66671C10.834 7.12504 11.209 7.50004 11.6673 7.50004H14.1673C15.5423 7.50004 16.6673 8.62504 16.6673 10C16.6673 11.375 15.5423 12.5 14.1673 12.5H11.6673C11.209 12.5 10.834 12.875 10.834 13.3334C10.834 13.7917 11.209 14.1667 11.6673 14.1667H14.1673C16.4673 14.1667 18.334 12.3 18.334 10C18.334 7.70004 16.4673 5.83337 14.1673 5.83337ZM6.66724 10.0001C6.66724 10.4584 7.04224 10.8334 7.50057 10.8334H12.5006C12.9589 10.8334 13.3339 10.4584 13.3339 10.0001C13.3339 9.54172 12.9589 9.16672 12.5006 9.16672H7.50057C7.04224 9.16672 6.66724 9.54172 6.66724 10.0001Z"
      fill={color}
    />
  </svg>
);
